// extracted by mini-css-extract-plugin
export default {"header":"header-component_header__Ix8yq","headerContent":"header-component_headerContent__BPk6b"};